import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { FrsBrowseComponent } from './frsBrowse/frs.browse.component';
import { FrsRoadmapComponent } from './frsRoadmap/frs.roadmap.component';
import { FrsReleaseDetailsComponent } from './frsReleaseDetails/frs.release.details.component';
import { ProjectHeaderComponent } from '../../core/modules/project/projectHeader/project.header.component';

import { FrsResolvesService } from './frs-resolves.service';
import { TourService } from '../../core/modules/tour/tour.service';
import { ProjectModel } from '../../core/services/project.model.service';

export const FRS_STATES: any[] = [
    {
        name: 'home.project.summary.frs',
        url: '/frs?page_num&page_size&sort_field&sort_dir&_textsearch&packageId&isVisible&isPublic&isReleased&releaseDateTo&releaseDateFrom',
        reloadOnSearch: false,
        params: {
            page_num: {
                value: '1',
                squash: true
            },
            page_size: {
                value: '20',
                squash: true
            },
            sort_field: {
                value: 'priority',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            '_textsearch': {
                value: '',
                squash: true
            },
            packageId: {
                value: 0,
                type: 'int',
                squash: true
            },
            isVisible: {
                value: '',
                squash: true
            },
            isPublic: {
                value: '',
                squash: true
            },
            isReleased: {
                value: '',
                squash: true
            },
            releaseDateFrom: {
                value: '',
                squash: true
            },
            releaseDateTo: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'security',
                deps: ['project', FrsResolvesService, ProjectModel],
                resolveFn: async (project: any, frsResolvesService: FrsResolvesService, projectModel: ProjectModel) => {
                    return frsResolvesService.security(project, projectModel);
                }
            },
            {
                token: 'tour',
                deps: ['$transition$', FrsResolvesService, TourService],
                resolveFn: async (transition: any, frsResolvesService: FrsResolvesService, tourService: TourService) => {
                    return frsResolvesService.frsTour(tourService, transition);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: FrsBrowseComponent
            }
        }
    },
    {
        name: 'home.project.summary.frs.roadmap',
        url: '/roadmap',
        resolve: [
            {
                token: 'security',
                deps: ['project', FrsResolvesService, ProjectModel],
                resolveFn: async (project: any, frsResolvesService: FrsResolvesService, projectModel: ProjectModel) => {
                    return frsResolvesService.security(project, projectModel);
                }
            },
            {
                token: 'tour',
                deps: [FrsResolvesService, TourService],
                resolveFn: async (frsResolvesService: FrsResolvesService, tourService: TourService) => {
                    return frsResolvesService.roadmapTour(tourService);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: FrsRoadmapComponent
            }
        }
    },
    {
        name: 'home.project.summary.frs.details',
        url: '/:releaseId/details',
        reloadOnSearch: false,
        resolve: [
            {
                token: 'security',
                deps: ['project', FrsResolvesService, ProjectModel],
                resolveFn: async (project: any, frsResolvesService: FrsResolvesService, projectModel: ProjectModel) => {
                    return frsResolvesService.security(project, projectModel);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: FrsReleaseDetailsComponent
            }
        }
    }
];